<template>
    <div class="product">
        <div class="banner">
            <div class="box1">
                <!-- <div class="tx1"> -->
                <img class="tx1" src="../../assets/model.png">
                <!-- </div> -->
                <div class="tx2">
                    <div class="bigtx">
                        众享租房——省钱、省事、省心
                    </div>
                    <div class="smalltx">
                        基于定位地图找房，高效便捷
                    </div>
                    <div class="smalltx">
                        多条件精确搜索房源，精准找房
                    </div>
                </div>
                <div class="tx3">
                    <img class="tx3img" src="../../assets/btn.png">
                    <div class="kefurcode">
                        <img src="../../../static/routine.png" class="kefucode">
                    </div>
                </div>
                <div class="tx4">
                    <img class="tx4img" src="../../assets/play.png">
                    <div class="kefurcode">
                        <img src="../../../static/routine.png" class="kefucode">
                    </div>
                </div>
            </div>
            <div class="box2">
                <!-- <img src="../../assets/artwork.png"> -->
            </div>
        </div>
        <div class="top">
            <!-- <img src="../../assets/about.png" /> -->
            <div class="content">
                <div class="about"> ———— 关于众享租房</div>
                <div class="title"> 无中介房屋信息发布平台</div>
                <div class="tips"> 快速出租、转租、求租、找室友</div>
                <div class="pro">
                    微信搜一搜 “众享租房” <span class="icon"> > </span>
                </div>
            </div>
        </div>
        <div class="center">
            <img src="../../assets/bg2.svg" />
        </div>
        <div class="bottom">
            <!-- <img src="../../../static/bg3.svg" /> -->
            <div class="des">
                <div class="destitle">房源遍布全国————热门城市<span class="marke">找房</span></div>
                <div class="content">
                    <div class="de1">众享租房中国房地产信息服务平台</div>
                    <div class="de1">众享租房提供全面实时的房东出租、房屋转租、在线求租、找室友等内容</div>
                    <div class="de1">为广大用户提供专业的无中介对接平台</div>
                </div>
            </div>
            <div class="xiaocxx">
                <img src="../../../static/target.png" class="target" />
                <div class="rimg"></div>
                <!-- <img src="../../assets/routine.png"  /> -->
                <div class="box">
                    <div class="tx">
                        <div class="tx1">微信扫码就加入</div>
                        <div class="tx2">@众享租房</div>
                    </div>
                    <div class="tx">
                        <img src="../../assets/stars.png">
                    </div>
                </div>
                <div class="describe">
                    “一个很方便、快捷、高效的转租平台，找到了很好的租客”<br />
                    “房东直租给我的房子，无中介费，对租房人太友好啦!“
                </div>
                <div class="user">
                    <div class="tx1">科融万户</div>
                    <div class="tx2">@众享租房用户</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "product",
    data() {
        return {}
    },
    components: {},
    methods: {}
}
</script>

<style lang="scss" scoped>
.product {
    // background: #fff;

    .banner {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .box1 {
            display: flex;
            flex-direction: column;
            padding-left: 60px;
            justify-content: flex-end;
            align-items: flex-start;

            .tx1 {
                // img {
                width: 285px;
                // }
            }

            .tx2 {
                .bigtx {
                    font-size: 50px;
                    color: #222222;
                    padding: 18px 0;
                }

                .smalltx {
                    font-size: 20px;
                    color: #222222;
                    padding: 8px 0;
                }
            }

            .tx3 {
                // padding-top: 30px;
                position: relative;

                &:hover {
                    .kefurcode {
                        visibility: visible;
                        z-index: 99;

                        .kefucode {
                            width: 166px;
                        }
                    }
                }

                .kefurcode {
                    visibility: hidden;
                    background: #fff;
                    position: absolute;
                    top: 95px;
                    left: -10px;
                    padding: 10px 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 12px;
                    box-shadow: 1px 1px 12px rgba(115, 115, 115, .5);

                    &::after {
                        content: '';
                        border-left: 10px solid transparent;
                        border-bottom: 10px solid #fff;
                        border-right: 10px solid transparent;
                        width: 0;
                        height: 0;
                        position: absolute;
                        top: -10px;
                    }
                }

                .tx3img {
                    width: 156px;
                }
            }

            .tx4 {
                position: relative;
                margin-top: -30px;

                &:hover {
                    .kefurcode {
                        visibility: visible;
                        z-index: 99;

                        .kefucode {
                            width: 166px;
                        }
                    }
                }

                .kefurcode {
                    visibility: hidden;
                    background: #fff;
                    position: absolute;
                    top: 95px;
                    left: -10px;
                    padding: 10px 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 12px;
                    box-shadow: 1px 1px 12px rgba(115, 115, 115, .5);

                    &::after {
                        content: '';
                        border-left: 10px solid transparent;
                        border-bottom: 10px solid #fff;
                        border-right: 10px solid transparent;
                        width: 0;
                        height: 0;
                        position: absolute;
                        top: -10px;
                    }
                }

                .tx4img {
                    width: 266px;

                }

            }
        }

        .box2 {
            background-image: url('static/artwork.png');
            background-repeat: no-repeat;
            background-size: 545px 573px;
            width: 545px;
            height: 573px;
            padding-top: 40px;
            // img {
            //     width: 545px;
            // }
        }
    }

    .top {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: -80px;
        background-image: url('static/about.png');
        background-repeat: no-repeat;
        background-size: 1920px 850px;
        width: 1920px;
        height: 850px;

        // img {
        //     width: 100%;
        // }
        .content {
            margin-right: 300px;
            display: flex;
            flex-direction: column;

            .about {
                font-size: 18px;
                font-weight: bold;
                color: #fff;
            }

            .title {
                font-size: 46px;
                // font-weight: bold;
                color: #fff;
                padding: 20px 0;
            }

            .tips {
                font-size: 32px;
                font-weight: 300;
                color: #fff;
                padding-bottom: 20px;
            }

            .pro {
                color: #737373;
                font-size: 14px;
                background: #fff;
                border-radius: 26px;
                padding: 15px 25px;
                width: 158px;

                .icon {
                    color: #46D7A3;
                    font-weight: bolder;
                }
            }
        }
    }

    .center {
        display: flex;
        justify-content: center;
        padding: 30px 0;
        align-items: center;

        img {
            width: 1240px;
        }
    }

    .bottom {
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 30px 0;
        position: relative;
        align-items: center;
        background-image: url('/static/ground.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .des {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .destitle {
                font-size: 44px;
                color: #272D4E;
                padding: 15px 0;

                .marke {
                    color: #0AC05E;
                }
            }

            .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .de1 {
                    color: #676A6C;
                    font-size: 22px;
                }
            }
        }

        img {
            width: 688px;
        }

        // background-image: url('../../assets/bg3.png');
        // background-size: 100% 100%;
        // background-repeat: no-repeat;
        .xiaocxx {
            // position: absolute;
            // top: 320px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            width: 500px;
            box-shadow: 0px 19px 12px rgba(115, 115, 115, .5);
            border-radius: 22px;
            padding: 30px 0;
            margin-top: 60px;

            .target {
                width: 118.11px;
                height: 118.11px;
                margin-top: -75px;
            }

            .rimg {
                width: 300px;
                height: 300px;
                background-image: url('/static/routine.png');
                background-size: 300px 300px;
                background-repeat: no-repeat;
            }

            .box {
                display: flex;
                justify-content: space-between;
                padding: 40px 30px 0;
                box-sizing: border-box;
                width: 500px;

                .tx {
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    flex-direction: column;

                    img {
                        width: 139px;
                    }

                    .tx1 {
                        color: #313131;
                        font-size: 19.35px;
                    }

                    .tx2 {
                        color: #425466;
                        font-size: 13.82px;
                    }
                }
            }

            .describe {
                line-height: 38px;
                font-size: 22px;
                padding: 0 30px;
                box-sizing: border-box;
            }

            .user {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                flex-direction: column;
                align-items: flex-end;
                padding-top: 80px;
                padding-right: 48px;

                .tx1 {
                    color: #313131;
                    font-size: 19px;
                }

                .tx2 {
                    color: #425466;
                    font-size: 14px;
                }
            }
        }


    }
}
</style>



// WEBPACK FOOTER //
// src/page/product/index.vue